import React from 'react';
import data from '../../data/home5_residence/faq.json';

function FAQ() {
    return (
        <section className="tc-faq-style5">
            <div className="container">
                <div className="content">
                    <div className="title mb-80">
                        <div className="row justify-content-between">
                            <div className="col-lg-6">
                                <h2 className="fsz-60 text-uppercase fw-400 js-splittext-lines">
                                    <span className="color-brown1">Frequently Asked</span> <br /> Questions
                                </h2>
                            </div>
                            <div className="col-lg-5">
                                <h6 className="color-brown1 text-uppercase fsz-20 lh-4 js-splittext-lines">
                                    Everything you need to know about our advisory-led
                                    real estate solutions.
                                </h6>
                            </div>
                        </div>
                    </div>

                    <div className="faq-accordion">
                        <div className="accordion" id="faqAccordion">
                            {data.map((item, i) => (
                                <div key={i} className="accordion-item wow fadeInUp slow" data-wow-delay={`${0.1 * (i + 1)}s`}>
                                    <div className="accordion-header" id={`heading${i}`}>
                                        <button
                                            className="accordion-button collapsed"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#collapse${i}`}
                                            aria-expanded="false"
                                            aria-controls={`collapse${i}`}
                                        >
                                            <span className="num color-brown1">{i + 1 < 10 ? `0${i + 1}` : i + 1}</span>
                                            <span className="question-text">{item.question}</span>
                                        </button>
                                    </div>
                                    <div
                                        id={`collapse${i}`}
                                        className="accordion-collapse collapse"
                                        aria-labelledby={`heading${i}`}
                                        data-bs-parent="#faqAccordion"
                                    >
                                        <div className="accordion-body">
                                            <br />
                                            <p className="fsz-16 color-999">
                                                {item.answer}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default FAQ;
